import {
  isInstalled,
  isRunningAsPWA,
  isRunningAsTWA,
} from "../../utils/pwaTwa/detectionHelper";

export const isAdtraceAllowed = (): boolean => {
  if (typeof window === "undefined") return false;

  return (
    import.meta.env.VITE_ADTRACE_ENABLE === "true" &&
    !!import.meta.env.VITE_ADTRACE_APP_TOKEN &&
    isInstalled() // PWA or TWA only
  );
};

export const isAdtracePwaAllowed = (): boolean => {
  return isRunningAsPWA(); // PWA  only
};

export const isAdtraceTwaAllowed = (): boolean => {
  return isRunningAsTWA(); // TWA  only
};
